import axios from "axios";
import { paramsConfig } from "../../utils/paramsUtils";
import { ISearchDetail } from "../models/reportModels";
import { localStorageItem } from "../../utils/localStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
const API_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_API_URL;

export const getReportDetail = (searchObj: ISearchDetail) => {
  let url = API_URL + `/bao-cao`;
  return axios.get(url, paramsConfig(searchObj));
};
